const firebaseConfig = {
    apiKey: "AIzaSyAIzoEZ5EibvRRBRXTK8b5M1_zI4w4aZbk",
    authDomain: "coins-world-d1714.firebaseapp.com",
    projectId: "coins-world-d1714",
    storageBucket: "coins-world-d1714.appspot.com",
    messagingSenderId: "775356043084",
    appId: "1:775356043084:web:f5716481f3ab5fbe5c49e9"
  };

  export default firebaseConfig;